<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Map">
<div class="ipadfp"><span aria-label=" page vi. " epub:type="pagebreak" id="page_vi" role="doc-pagebreak"><span aria-label=" page vii. " epub:type="pagebreak" id="page_vii" role="doc-pagebreak"><span aria-label=" page viii. " epub:type="pagebreak" id="page_viii" role="doc-pagebreak"><span aria-label=" page ix. " epub:type="pagebreak" id="page_ix" role="doc-pagebreak"><span aria-label=" page x. " epub:type="pagebreak" id="page_x" role="doc-pagebreak"><span aria-label=" page xi. " epub:type="pagebreak" id="page_xi" role="doc-pagebreak"><img alt="Image" class="imagefp" src="e9781439132081/images/f00xi-01.jpg"/></span></span></span></span></span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?e764ae2c